import { LockScreen } from './components';
import './App.css';

function App() {
  return <LockScreen />;
}

export default App;
